











































































































































import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import rules from "../../utils/rules";
import { checkLicense, formatPrice } from "../../utils/general-functions";
import constants from "../../config/constants";

@Component
export default class UpdateLicenseDialog extends Vue {
  @Prop() dialogUpdate!: boolean;
  @Prop() license!: any;
  @Prop() licenses!: any;
  @Prop() page!: number;

  notZero = [rules.notZero];
  costRules = [rules.notEmpty, rules.positive];
  generalRules = [rules.notEmpty];

  $refs!: {
    formUpdate: HTMLFormElement;
  };

  valid = true;
  loadingUpdate = false;
  snackbarSuccessUpdate = false;
  snackbarErrorUpdate = false;
  snackbarError2Create = false;
  licenseCost = 0;
  currentLicenseTerm = 0;
  currentLicenseEquipments = 0;

  private created(): void {
    this.currentLicenseTerm = this.license.licenseTerm;
    this.currentLicenseEquipments = this.license.licenseEquipments;
    this.licenseCost = this.license.licenseCost;
  }

  private cancelUpdate(): void {
    this.$emit("cancelUpdate");
  }

  private formatPrice(value: any): string {
    return formatPrice(value);
  }

  private updateLicense(): void {
    if (
      this.currentLicenseTerm !== this.license.licenseTerm ||
      this.currentLicenseEquipments !== this.license.licenseEquipments
    ) {
      if (
        checkLicense(
          this.licenses,
          this.license.licenseTerm,
          this.license.licenseEquipments,
          true,
          this.license.licenseID
        )
      ) {
        this.updateLicenseStore();
      } else {
        this.snackbarError2Create = true;
      }
    } else {
      this.updateLicenseStore();
    }
  }

  private updateLicenseStore(): void {
    this.loadingUpdate = true;
    this.$store
      .dispatch("product/updateLicenseToProduct", {
        licenseId: this.license.licenseID,
        equipments: this.license.licenseEquipments,
        status: this.license.licenseStatus,
        cost: this.licenseCost,
        term: this.license.licenseTerm,
        start: this.page * constants.ITEMS_PER_PAGE - constants.ITEMS_PER_PAGE,
        quantity: constants.ITEMS_PER_PAGE
      })
      .then((response: boolean) => {
        if (response) {
          this.snackbarError2Create = false;
          this.snackbarSuccessUpdate = true;
        } else {
          this.snackbarErrorUpdate = true;
        }

        this.loadingUpdate = false;
        this.$emit("cancelUpdate");
      });
  }

  private get allStatus(): Array<string> {
    return this.$store.getters["common/getStatus"];
  }
}
